/* SUVENE Bewertungs-Karussell Startseite: Pfeile, Fortschrittsstriche, Wischen auf Touch, Pfeiltasten im Fokus, "i"-Hinweis */
(function () {
  /* "i"-Hinweis: Hover (Desktop) und Antippen, Escape schließt; Position bleibt im Bildschirm */
  function place(w) {
    var tip = w.querySelector('.su-rv-i__tip');
    if (!tip) return;
    tip.style.setProperty('--sh', '0px');
    var r = tip.getBoundingClientRect(), vw = document.documentElement.clientWidth, sh = 0;
    if (r.left < 8) sh = 8 - r.left;
    else if (r.right > vw - 8) sh = vw - 8 - r.right;
    tip.style.setProperty('--sh', Math.round(sh) + 'px');
  }
  if (!window.__suRvInfo) {
    window.__suRvInfo = true;
    document.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.su-rv-i__btn') : null;
      document.querySelectorAll('.su-rv-i.is-open').forEach(function (w) {
        if (!b || w !== b.parentNode) { w.classList.remove('is-open'); w.querySelector('.su-rv-i__btn').setAttribute('aria-expanded', 'false'); }
      });
      if (!b) return;
      e.preventDefault();
      var w = b.parentNode, open = !w.classList.contains('is-open');
      w.classList.toggle('is-open', open);
      b.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) place(w);
    });
    document.addEventListener('mouseover', function (e) {
      var w = e.target.closest ? e.target.closest('.su-rv-i') : null;
      if (w) place(w);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') document.querySelectorAll('.su-rv-i.is-open').forEach(function (w) { w.classList.remove('is-open'); });
    });
  }

  function init(root) {
    if (!root || root.hasAttribute('data-ready')) return;
    root.setAttribute('data-ready', '');
    var slides = root.querySelectorAll('.su-rv__slide');
    var segs = root.querySelectorAll('.su-rv__segs i');
    var count = root.querySelector('[data-su-rv-count]');
    var total = slides.length;
    if (total < 2) return;
    var cur = 0;
    function pad(n) { return n < 10 ? '0' + n : String(n); }
    function show(i) {
      cur = (i + total) % total;
      for (var k = 0; k < total; k++) {
        var on = k === cur;
        slides[k].classList.toggle('is-on', on);
        slides[k].setAttribute('aria-hidden', on ? 'false' : 'true');
        if (segs[k]) segs[k].classList.toggle('is-on', on);
      }
      if (count) count.textContent = pad(cur + 1) + ' / ' + pad(total);
      fit();
    }
    /* Aufbau "geteilt": Hoehe der Buehne folgt dem aktuellen Zitat (weicher Uebergang in CSS), lange Zitate mit "Mehr lesen" */
    var split = root.classList.contains('su-rv--split');
    var stageEl = root.querySelector('.su-rv__stage');
    function fit() {
      if (!split || !stageEl || !slides[cur]) return;
      /* Vito 19.10.: Hoehe bleibt stehen, so hoch wie das laengste (eingeklappte) Zitat; aufgeklapptes Zitat darf wachsen */
      var h = 0;
      for (var k = 0; k < total; k++) { if (!slides[k].classList.contains('is-open')) h = Math.max(h, slides[k].offsetHeight); }
      h = Math.max(h, slides[cur].offsetHeight);
      stageEl.style.height = h + 'px';
    }
    function clampCheck() {
      if (!split) return;
      for (var k = 0; k < total; k++) {
        var sl = slides[k], q = sl.querySelector('.su-rv__quote'), more = sl.querySelector('[data-su-rv-more]');
        if (!q || !more || sl.classList.contains('is-open')) continue;
        more.hidden = q.scrollHeight <= q.clientHeight + 2;
      }
      fit();
    }
    if (split) {
      root.addEventListener('click', function (e) {
        var b = e.target.closest ? e.target.closest('[data-su-rv-more]') : null;
        if (!b) return;
        var sl = b.closest('.su-rv__slide');
        var open = !sl.classList.contains('is-open');
        if (!b.dataset.more) b.dataset.more = b.textContent;
        sl.classList.toggle('is-open', open);
        b.textContent = open ? b.dataset.less : b.dataset.more;
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        fit();
      });
      stageEl.classList.add('is-instant');
      clampCheck();
      requestAnimationFrame(function () { stageEl.classList.remove('is-instant'); });
      if ('ResizeObserver' in window) new ResizeObserver(function () { clampCheck(); }).observe(stageEl);
      window.addEventListener('load', clampCheck);
    }
    var next = root.querySelector('[data-su-rv-next]');
    var prev = root.querySelector('[data-su-rv-prev]');
    if (next) next.addEventListener('click', function () { show(cur + 1); });
    if (prev) prev.addEventListener('click', function () { show(cur - 1); });
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') show(cur + 1);
      if (e.key === 'ArrowLeft') show(cur - 1);
    });
    var stage = root.querySelector('.su-rv__stage');
    var x0 = null, y0 = null;
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(cur + (dx < 0 ? 1 : -1));
      x0 = y0 = null;
    }, { passive: true });
  }
  function all() { document.querySelectorAll('[data-su-reviews]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
